export enum DeliverOption {
  DROP_AT_DOOR = "drop_at_door",
  DROP_AT_MAILBOX = "drop_at_mailbox",
  DROP_AT_FRONT_DESK = "drop_at_front_desk",
  RETURN_ON_FAILED = "return",
  REATTEMPT_ON_FAILED = "reattempt",
  CALL_ME_TO_CONFIRM = "call_me_to_confirm",
  DELIVERY_VERIFICATION_PIN="delivery_verification_pin",
  SIGNATURE_REQUIRED="Signature Required"
}
